export function initTwoFaSubmitButtons(): void {
  const emailRadioInput = document.getElementById('two-fa-email-radio') as HTMLInputElement | null;
  const emailInput = document.querySelector<HTMLInputElement>('#TwoFaEmailConfirmation');
  const emailButton = document.querySelector<HTMLButtonElement>('[data-component="2faEmailSubmitBtn"]');

  const phoneRadioInput = document.getElementById('two-fa-phone-radio') as HTMLInputElement | null;
  const phoneInput = document.querySelector<HTMLInputElement>('#TwoFaPhoneConfirmation');
  const phoneButton = document.querySelector<HTMLButtonElement>('[data-component="2faPhoneSubmitBtn"]');

  function updateRadioSelection() {
    const urlParams = new URLSearchParams(globalThis.location.search);
    const method = urlParams?.get('method');

    if (!method) return;
    if (method === 'Email' && emailRadioInput) {
      emailRadioInput.checked = true;
    } else if (method === 'Phone' && phoneRadioInput) {
      phoneRadioInput.checked = true;
    }
  }

  updateRadioSelection();

  function validateEmailInput() {
    if (!emailInput || !emailButton) return;

    const value = emailInput.value.trim();
    const isValid = emailInput.checkValidity();

    emailButton.disabled = !(value && isValid);
  }

  function validatePhoneInput() {
    if (!phoneInput || !phoneButton) return;

    const value = phoneInput.value.trim();
    const isValid = phoneInput.checkValidity();

    phoneButton.disabled = !(value && isValid);
  }

  // Email input validation
  if (emailInput) {
    emailInput.addEventListener('input', validateEmailInput);
    emailInput.addEventListener('blur', validateEmailInput);
  }

  // Phone input validation
  if (phoneInput) {
    phoneInput.addEventListener('input', validatePhoneInput);
    phoneInput.addEventListener('blur', validatePhoneInput);
  }
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTwoFaSubmitButtons);
} else {
  initTwoFaSubmitButtons();
}
